/**
 * ヘッダーナビ — 子メニューあり項目のドロップダウン（PC: ホバー / クリック）
 */
(function () {
  const DESKTOP_QUERY = '(min-width: 990px)';

  function isDesktop() {
    return window.matchMedia(DESKTOP_QUERY).matches;
  }

  function closeOtherMenus(currentDetails) {
    document.querySelectorAll('header-menu details[open]').forEach((details) => {
      if (details !== currentDetails) {
        details.removeAttribute('open');
      }
    });
  }

  function syncSummaryAria(details) {
    const summary = details.querySelector('summary');
    if (!summary) return;
    summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
  }

  function initHeaderMenus(scope) {
    (scope || document).querySelectorAll('header-menu').forEach((menu) => {
      if (menu.dataset.yamagaNavInit === 'true') return;
      menu.dataset.yamagaNavInit = 'true';

      const details = menu.querySelector('details');
      if (!details) return;

      const summary = details.querySelector('summary');
      if (summary) {
        summary.setAttribute('aria-haspopup', 'true');
        syncSummaryAria(details);
      }

      let closeTimer;

      details.addEventListener('toggle', () => {
        syncSummaryAria(details);
        if (details.open && isDesktop()) {
          closeOtherMenus(details);
        }
      });

      menu.addEventListener('mouseenter', () => {
        if (!isDesktop()) return;
        window.clearTimeout(closeTimer);
        closeOtherMenus(details);
        details.setAttribute('open', '');
      });

      menu.addEventListener('mouseleave', () => {
        if (!isDesktop()) return;
        closeTimer = window.setTimeout(() => {
          details.removeAttribute('open');
        }, 120);
      });
    });
  }

  const SWYM_WISHLIST_LINK_SELECTOR =
    '#swym-advanced-header-icon, #dawn-desktop, #dawn-mobile, a.swym-header-launcher';

  function isSwymWishlistLink(link) {
    if (!link || !link.closest('.header__icons')) return false;
    const id = link.id;
    if (id === 'swym-advanced-header-icon' || id === 'dawn-desktop' || id === 'dawn-mobile') {
      return true;
    }
    return link.classList.contains('swym-header-launcher');
  }

  function hideSwymWishlistBadges(root) {
    (root || document).querySelectorAll('.swym-header-launcher-badge').forEach((badge) => {
      badge.style.setProperty('display', 'none', 'important');
      badge.style.setProperty('visibility', 'hidden', 'important');
      badge.style.setProperty('opacity', '0', 'important');
      badge.style.setProperty('width', '0', 'important');
      badge.style.setProperty('height', '0', 'important');
      badge.style.setProperty('overflow', 'hidden', 'important');
      badge.style.setProperty('pointer-events', 'none', 'important');
      badge.style.setProperty('position', 'absolute', 'important');
      badge.style.setProperty('left', '-9999px', 'important');
      badge.setAttribute('aria-hidden', 'true');
      badge.hidden = true;
    });
  }

  function applyWishlistLinkVisibility(root) {
    const container = (root || document).querySelector('.header__icons');
    if (!container) return;

    container.querySelectorAll(SWYM_WISHLIST_LINK_SELECTOR).forEach((link) => {
      if (!isSwymWishlistLink(link)) return;

      const block = link.closest('.shopify-app-block');
      link.style.removeProperty('display');
      if (block) block.style.removeProperty('display');
    });
  }

  function initSwymWishlistHeader(scope) {
    const root = scope || document;
    const icons = root.querySelector('.header__icons');
    if (!icons) return;

    const label = icons.dataset.wishlistLabel || 'お気に入り';
    let scheduled = false;
    let observer = null;

    function needsEnhance(link) {
      if (!link.classList.contains('header__icon--wishlist')) return true;

      const labelEl = link.querySelector('.header__icon-label');
      if (!labelEl || labelEl.textContent !== label) return true;

      const iconHtml = link.querySelector('.swym-header-icon-html');
      if (iconHtml && !iconHtml.closest('.header__icon-graphic')) return true;

      const graphic = link.querySelector('.header__icon-graphic');
      if (!graphic) return true;

      return false;
    }

    function wrapGraphicContent(link) {
      let graphic = link.querySelector('.header__icon-graphic');
      if (graphic) return graphic;

      graphic = document.createElement('span');
      graphic.className = 'header__icon-graphic';

      const nodesToMove = [];
      link.childNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE && node.classList.contains('header__icon-label')) {
          return;
        }
        if (
          node.nodeType === Node.ELEMENT_NODE &&
          node.classList.contains('swym-header-launcher-badge')
        ) {
          return;
        }
        if (node.nodeType === Node.TEXT_NODE && !node.textContent.trim()) {
          return;
        }
        nodesToMove.push(node);
      });

      if (nodesToMove.length) {
        link.insertBefore(graphic, nodesToMove[0]);
        nodesToMove.forEach((node) => graphic.appendChild(node));
      } else {
        link.prepend(graphic);
      }

      return graphic;
    }

    function enhance(link) {
      if (!isSwymWishlistLink(link)) return;
      if (!needsEnhance(link)) return;

      link.classList.add('header__icon', 'header__icon--wishlist');
      link.style.removeProperty('margin-right');
      link.style.removeProperty('font-size');
      link.style.removeProperty('position');
      link.setAttribute('aria-label', label);
      link.setAttribute('title', label);

      const graphic = wrapGraphicContent(link);

      const iconHtml = link.querySelector('.swym-header-icon-html');
      if (iconHtml && !iconHtml.closest('.header__icon-graphic')) {
        graphic.appendChild(iconHtml);
      }

      let labelEl = link.querySelector('.header__icon-label');
      if (!labelEl) {
        labelEl = document.createElement('span');
        labelEl.className = 'header__icon-label';
        labelEl.setAttribute('aria-hidden', 'true');
        link.appendChild(labelEl);
      }

      labelEl.textContent = label;
    }

    function runScan() {
      scheduled = false;
      if (observer) observer.disconnect();
      icons.querySelectorAll(SWYM_WISHLIST_LINK_SELECTOR).forEach(enhance);
      hideSwymWishlistBadges(document);
      applyWishlistLinkVisibility(root);
      if (observer) observer.observe(icons, { childList: true, subtree: true });
    }

    function scheduleScan() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(runScan);
    }

    runScan();

    if (icons.dataset.yamagaSwymObserved !== 'true') {
      icons.dataset.yamagaSwymObserved = 'true';
      observer = new MutationObserver(scheduleScan);
      observer.observe(icons, { childList: true, subtree: true });
    }

    if (window.SwymCallbacks && !window.yamagaSwymWishlistHeaderHooked) {
      window.yamagaSwymWishlistHeaderHooked = true;
      window.SwymCallbacks.push(scheduleScan);
    }

    if (!window.yamagaSwymWishlistResizeHooked) {
      window.yamagaSwymWishlistResizeHooked = true;
      window.addEventListener('resize', scheduleScan);
    }
  }

  function onReady() {
    initHeaderMenus();
    initSwymWishlistHeader();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initHeaderMenus(event.target);
    initSwymWishlistHeader(event.target);
  });
})();
